import type { User } from '@clockwise/clients/users';
import { userLabel } from '@/components/custom/entity-pickers';
import { cn } from '@/lib/utils';

/**
 * Picker row for a user: name over a muted email line. Label-area only — the
 * host picker (`EntityPicker` / `EntityMultiSelect`) renders the checkmark
 * gutter. The email line disambiguates near-identical names (e.g. two people
 * called "Rohith Sundra…"), so it's worth the second line app-wide. Shared by
 * the approvals filter and the timesheet-report filters.
 */
export function UserRow({ user, isSelected }: { user: User; isSelected: boolean }) {
  return (
    <div className="flex min-w-0 flex-col">
      <span className={cn('truncate', isSelected && 'font-medium')}>{userLabel(user)}</span>
      <span className="truncate text-xs text-muted-foreground">{user.email}</span>
    </div>
  );
}
